import { Checkbox, Dropdown } from '@yembo/yemblocks-core';
import { Dispatch } from 'react';
import { getAllowedSurveyTypeOptions } from 'src/react/_shared/SurveyTypeDropdown/utils';
import { ContactJobState, ContactComponentState, CreateContactFormData } from 'src/react/Contact';
import { CompanyDefaultSurveyType } from 'src/types';

type Props = {
  formData: CreateContactFormData;
  dispatchJobState: Dispatch<Partial<ContactJobState>>;
  job: ContactJobState;
  dispatchState: Dispatch<Partial<ContactComponentState>>;
  shouldIncludeSampleSurvey: boolean;
  isNoReviewCompany: boolean;
  state: ContactComponentState;
  isSelfSurvey: boolean;
  dispatchFormData: Dispatch<Partial<CreateContactFormData>>;
  isPhoneValid: boolean;
};

export const SurveySection = ({
  formData,
  dispatchJobState,
  job,
  dispatchState,
  shouldIncludeSampleSurvey,
  isNoReviewCompany,
  state,
  isSelfSurvey,
  dispatchFormData,
  isPhoneValid,
}: Props) => {
  const { shouldSendEmail, shouldSendSms, validation, insured } = formData;

  const { surveyType } = state;
  const { email, phone } = insured;

  const getSurveyTypeOptions = () => {
    const options: {
      key: CompanyDefaultSurveyType;
      name: string;
    }[] = getAllowedSurveyTypeOptions({
      isNoReviewCompany,
      shouldIncludeSampleSurvey,
    });

    return options;
  };

  return (
    <div className='section survey-section'>
      <p className='bold header'>Survey</p>
      <div className='column survey'>
        <Dropdown
          label='Survey Type'
          options={getSurveyTypeOptions().map((option) => ({
            key: `${option.key}_${option.name}`,
            name: option.name,
            isSelected: option.key === surveyType,
            onClick: () => dispatchState({ surveyType: option.key }),
          }))}
        />

        {isSelfSurvey && (
          <div className='checkboxes'>
            <Checkbox
              label='Send Email Invite'
              isChecked={shouldSendEmail}
              isDisabled={!email || !validation.isEmailValid}
              onChange={() => dispatchFormData({ shouldSendEmail: !shouldSendEmail })}
            />
            <Checkbox
              label='Send Text Invite'
              isDisabled={!phone || phone.length < 4 || !isPhoneValid}
              isChecked={shouldSendSms}
              onChange={() => dispatchFormData({ shouldSendSms: !shouldSendSms })}
            />
          </div>
        )}
      </div>
    </div>
  );
};
